import React from "react";
import styled from "styled-components";
import ReactTimeout from "react-timeout";
import { H3 } from "./typography";
import { HFlexFlipper } from "./blocks/Flex";
import { r } from "../utils";

const itemHeight = 36,
  fontSize = 24;

const Container = styled.div`
  overflow: hidden;
  position: relative;
  ${r("height", itemHeight * 1 + "px", fontSize * 1.2 + "px")};
  padding-left: .5rem;
`;

const List = styled.div`
  margin: 0;
  padding: 0;
  width: 240px;
  transition: top 300ms;
  position: relative;
  ${({ index }) =>
    r(
      "top",
      -itemHeight * ((index || 0) - 1) + "px",
      -0.875 * itemHeight * (index || 0) + "px"
    )};
  transition: top 300px;
`;

const Item = styled.li`
  list-style: none;
  ${r("text-align", "left", "center")};
  font-size: ${fontSize};
  line-height: 1.2;
`;

const WhatIfText = H3.extend`padding-bottom: 8rem;`;

class WhatIf extends React.Component {
  state = { whatIf: { list: [], index: 0 } };
  whatIfList = ["easy", "reliable", "long-lasting", "reversible"];
  _makeItem(item, index) {
    return {
      key: item + index,
      label: item
    };
  }
  _startWhatIfTimeout(cycleRate) {
    this.props.setTimeout(() => {
      const { whatIf: { list, index } } = this.state,
        nextWhatIf = this.whatIfList[
          ((index || 0) + 1) % this.whatIfList.length
        ],
        nextWhatIfItem = this._makeItem(nextWhatIf, list.length),
        nextList = list.concat([nextWhatIfItem]);
      this.setState({
        ...this.state,
        whatIf: {
          ...this.state.whatIf,
          index: (index || 0) + 1,
          list: nextList
        }
      });
      this._startWhatIfTimeout(cycleRate);
    }, cycleRate * 1000);
  }
  componentWillMount() {
    this.setState({
      whatIf: {
        list: this.whatIfList
          .slice(0, -2)
          .map((text, i) => this._makeItem(text, i)),
        index: 1
      }
    });
    this._startWhatIfTimeout(1.7);
  }
  render() {
    const { whatIf: { list, index } } = this.state;
    return (
      <div>
        <WhatIfText>
          <HFlexFlipper>
            What if
            <div style={{ display: "inline-block", padding: "0 .5rem" }}>
              <span style={{ color: "#43bcba" }}> male contraception </span>
            </div>
            was
            <Container>
              <List index={index}>
                {list.map(item =>
                  <Item key={item.key}>
                    {item.label}?
                  </Item>
                )}
              </List>
            </Container>
          </HFlexFlipper>
        </WhatIfText>
      </div>
    );
  }
}

export default ReactTimeout(WhatIf);



// WEBPACK FOOTER //
// ./src/components/WhatIf.js